<script>
    import { mapGetters } from "vuex";
    import FButtonSection from "@/components/FButtonSection";

    export default {
        name: "FPageStuck",
        components: { FButtonSection },

        computed: {
            ...mapGetters(["companySelected"])
        }
    };
</script>

<template>
    <section>
        <FButtonSection
            v-if='[1, 3].includes(companySelected.tipoEmpresa)'
            to='/estoque/combustiveis'
            icon='local_gas_station'
            title='Combustíveis'
            descr='Controle dos tanques'
        />
        <FButtonSection
            v-if='[2, 3].includes(companySelected.tipoEmpresa)'
            to='/estoque/produtos'
            icon='store'
            title='Produtos'
            descr='Produtos abaixo do estoque mínimo'
        />
    </section>
</template>